import React from "react";

import "./Banner.scss";

function GameBanner() {
  return (
    <header className="game-banner">
      <h1>BLACKBOX</h1>
      <h2>The ultimate game of hide and seek</h2>
    </header>
  );
}

export default GameBanner;
